module.exports = __webpack_public_path__ + "img/accessible.82df2c90.svg";